/**
 * INT-0009 — slim icon rail shared by the FOCUSED editing surfaces
 * (Appearance page and the /editor canvas — owner 2026-09-07: both trade
 * the 256px sidebar for preview/canvas real estate). Design-tool
 * convention: an exit plus the closest sibling tools, nothing else; the
 * current surface's icon is highlighted (active by pathname). Desktop
 * only — below lg each page keeps its own mobile navigation.
 */
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft, FileText, Mail, Palette, Pencil, Settings } from 'lucide-react';
import { cn } from '@/lib/utils';

// Icons mirror each destination's main-sidebar entry. Waivers + Email
// Templates + Settings joined the rail cluster 2026-09-11 (owner) — the
// whole System & Tools family now shares the focused-surface shell.
const ITEMS = [
  { name: 'Appearance', href: '/admin/appearance', Icon: Palette },
  { name: 'Site Editor', href: '/admin/editor', Icon: Pencil },
  { name: 'Waivers', href: '/admin/waivers', Icon: FileText },
  { name: 'Email Templates', href: '/admin/email-templates', Icon: Mail },
  { name: 'Settings', href: '/admin/settings', Icon: Settings },
];

export default function AdminRail() {
  const { pathname } = useLocation();
  return (
    <aside
      className="fixed top-0 left-0 z-10 hidden h-screen w-16 flex-col items-center gap-2 border-r bg-card py-4 lg:flex"
      aria-label="Admin tool navigation"
      data-testid="admin-rail"
    >
      <Link
        to="/admin/dashboard"
        title="Back to dashboard"
        aria-label="Back to dashboard"
        className="flex h-10 w-10 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
      >
        <ArrowLeft className="h-5 w-5" />
      </Link>
      <div className="my-2 h-px w-8 bg-border" aria-hidden="true" />
      {ITEMS.map(({ name, href, Icon }) => {
        const active = pathname.startsWith(href);
        return (
          <Link
            key={href}
            to={href}
            title={name}
            aria-label={name}
            aria-current={active ? 'page' : undefined}
            className={cn(
              'flex h-10 w-10 items-center justify-center rounded-lg transition-colors',
              active
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground',
            )}
          >
            <Icon className="h-5 w-5" />
          </Link>
        );
      })}
    </aside>
  );
}
